import moment from 'moment';

export default [function () {
    let cachedAvailability = {};

    const datesCached = (eventType, eventId, fromDate, toDate, cache = []) => {
        let cached = checkCache(eventType, eventId, fromDate);

        if (!cached) {
            return [];
        }

        cache.push(cached);

        if (fromDate === toDate) {
            return cache;
        }

        fromDate = moment(fromDate).add(1, 'day').format('YYYY-MM-DD');

        return datesCached(eventType, eventId, fromDate, toDate, cache);
    };

    const updateCache = (eventType, eventId, response) => {
        response.forEach(availability => {
            cachedAvailability[eventType] = cachedAvailability[eventType] || {};
            cachedAvailability[eventType][eventId] = cachedAvailability[eventType][eventId] || {};

            cachedAvailability[eventType][eventId][availability.date] = availability;
        });

        return cachedAvailability;
    };

    const uncacheDate = (eventType, eventId, date) => {
        if (
            cachedAvailability[eventType] &&
            cachedAvailability[eventType][eventId]
        ) {
            delete (cachedAvailability[eventType][eventId][date]);
            return cachedAvailability[eventType][eventId];
        }
    };

    const checkCache = (eventType, eventId, date) => {
        if (
            cachedAvailability[eventType] &&
            cachedAvailability[eventType][eventId] &&
            cachedAvailability[eventType][eventId][date]
        ) {
            return cachedAvailability[eventType][eventId][date];
        }
    };

    return {
        updateCache,
        datesCached,
        uncacheDate,
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/services/availability.cache.service.js